import { useContext } from 'react';
import { ToastContext } from './ToastContext';

export default function useToast() {
  const toast = useContext(ToastContext);

  if (!toast) {
    throw new Error("useToast: no ToastProvider mounted. Mount <SharedProviders> (from 'shared').");
  }

  return toast;
}
